import { useSelector } from 'react-redux';
import { KoddiUser } from 'api/Admin/User';

// eslint-disable-next-line import/no-cycle
import { selectAuthUser } from './selectors';

/** Selected the current authenticated user from the redux auth state. */
export function useAuthUser(): KoddiUser | null {
    return useSelector(selectAuthUser);
}
